/* eslint-disable import/no-duplicates */
import Checkmark from '@atom-web/icons-24/jsx/Checkmark'
import CloseLine from '@atom-web/icons-24/jsx/CloseLine'
import { Box, Column } from '@atom-web/micros'
import { useDidUpdate } from '@pyt/hooks'
import { ChevronRight } from '@pyt/icons'
import { Modal } from '@pyt/macros'
import { Button, Input, Pressable, Space, Text } from '@pyt/micros'
import dayjs from 'dayjs'
import { truncate } from 'lodash'
import { useRouter } from 'next/router'
import queryString from 'query-string'
import { Fragment, useContext, useEffect, useMemo, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { ScrollView } from 'react-native'
import styled from 'styled-components'

import { AppConfig } from '../../../app-config'
import { FilterFooter } from '../../../components/FilterModal'
import { validateEmail } from '../../../components/footer'
import AirportCityDropdown from '../../../components/gcm/AirportCityDropdown'
import CustomerEmail from '../../../components/gcm/components/CustomerEmail'
import CustomerEmailOrMobile from '../../../components/gcm/components/CustomerEmailOrMobile'
import CustomerMobile from '../../../components/gcm/components/CustomerMobile'
import CustomerName from '../../../components/gcm/components/CustomerName'
import CustomerPassword from '../../../components/gcm/components/CustomerPassword'
import {
	COSTING_INFO,
	CRUISE_CABIN_CONFIG_GCM,
	DEPARTURE_AIRPORT_CHANGE,
	DEPARTURE_DATE_CHANGED,
	GCM_INDIAN_CITIES,
	GCM_OTP,
	GCM_PASSENGER_INFO,
	GCM_RESET_DEFAULT_LOGIN,
	GCM_RESET_PASSENGER_INFO,
	GCM_SIGNUP_FAILS_RESET,
	JOURNEY,
	LOGIN_ERROR,
	LOGIN_FORM_GCM,
	NATIONALITY_GLOBAL,
	PAID_LANDING_GCM,
	SET_ENABLE_GET_COST,
	SET_FORGOT_PASSWORD,
	SIGNUP_FORM_GCM,
	UPDATE_COSTING,
} from '../../../components/gcm/Constants'
import DepartureDate from '../../../components/gcm/DepartureDate'
import GCMContext from '../../../components/gcm/GCMContext'
import Duration from '../../../components/gcm/macros/Duration'
import ModalHeader from '../../../components/gcm/macros/ModalHeader'
import RoomsInfo from '../../../components/gcm/macros/RoomsInfo'
import {
	DEPARTURE_CITY,
	DEPARTURE_DATE,
	DURATION,
	ROOM_INFO,
} from '../../../components/gcm/routeConstant'
import getCostingText from '../../../components/gcm/utils/getCostingText'
import getGCMDefaultData from '../../../components/gcm/utils/getGCMDefaultData'
import getIndianCities from '../../../components/gcm/utils/getIndianCities'
import isLoginFormValid from '../../../components/gcm/utils/isLoginFormValid'
import isSignupFormValid from '../../../components/gcm/utils/isSignupFormValid'
import LeftSideBanner from '../../../components/gcm/widgets/LeftSideBanner'
import AppContext from '../../../store/AppContext'
import { SET_USER_DETAILS } from '../../../store/Constants'
import nationalityCountriesList from '../../../utils/countryListData'
import { decodeHotelRoomConfig } from '../../../utils/decodeHotelRoomConfig'
import { encodeHotelRoomConfig } from '../../../utils/encodeHotelRoomConfig'
import { getPaxCount } from '../../../utils/getPaxCount'
import getSafariDateFormat from '../../../utils/getSafariDateFormat'
import getWebsiteContactNumber from '../../../utils/getWebsiteContactNumber'
import { triggerSimpleAjax } from '../../../utils/http-helper'
import getLocale from '../../../utils/locale-helpers/getLocale'
import get from '../../../utils/lodashUtils/get'
import isEmpty from '../../../utils/lodashUtils/isEmpty'
import sumBy from '../../../utils/lodashUtils/sumBy'
import { emailValidation } from '../../../utils/validations'
import { triggerForgotPassword } from '../../auth/actions/forgotPassword'
import { triggerLogin } from '../../auth/actions/login'
import { triggerLoginWithOTP } from '../../auth/actions/loginWithOTP'
import { triggerRquestCallback } from '../../auth/actions/requestCallbackUser'
import isValidMobileNumber from '../../auth/utils/isValidMobileNumber'
import { preloadLibPhoneNumberMetaData } from '../../auth/utils/preloadLibPhoneNumberMetaData'
import triggerPrecostedMaldivesDeal from '../../maldives/pre-costed/actions/triggerPrecostedMaldivesDeal'
import triggerTourPackageViewDeal from '../../tour-packages/actions/triggerTourPackageViewDeal'
import triggerPackageGetCost from '../actions/triggerPackageGetCost'
//import { TalkToExpert } from '../components/TalkToExpert'

const ModalWrapper = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	overflow: auto;
	position: relative;
`

const RightSideContainer = styled.div`
	width: ${props => props.width || '60%'};
	display: flex;
	height: 100%;
	overflow: auto;
	flex-direction: column;
	position: relative;
	border-radius: 0 8px 8px 0;
	padding-bottom: ${props => props.pb || '0px'};
`

const GcmModal = ({ itineraryInfo, regionName, onSuccess }) => {
	const router = useRouter()
	const locale = getLocale({ router })

	const [modalState, setModalState] = useState(null)
	const [ctaLoading, setCtaLoading] = useState(false)
	const [{ userDetails }, appDispatch] = useContext(AppContext)

	const [otp, setOtp] = useState(null)
	const [otpResponse, setOtpResonse] = useState(null)
	const [password, setPassword] = useState(null)
	const [counter, setCounter] = useState(20)
	const [resendDisable, setResendDisable] = useState(true)
	const [showErrorModal, setShowErrorModal] = useState(false)
	const [passengerType, setPassengerType] = useState('')
	const [isSuccess, setIsSuccess] = useState(null)
	const [hideCTA, setHideCTA] = useState(false)

	const [visible, setVisible] = useState(false)
	const _global_user = router.locale !== router.defaultLocale

	// Modal data
	const modalName = useMemo(() => router.query?.m, [router])
	const itineraryTitle = useMemo(() => router.query?.name, [router])
	const regionCode = useMemo(() => router.query?.rc, [router])
	const destination = useMemo(() => router.query?.rn, [router])
	const isLoggedIn = useMemo(() => get(userDetails, 'loggedIn'), [userDetails])
	const price = useMemo(() => router.query?.price, [router])
	const [openJourneyModal, setopenJourneyModal] = useState(false)
	const websiteContactNumber = useMemo(
		() => getWebsiteContactNumber(locale),
		[locale],
	)

	const [state, dispatch] = useContext(GCMContext)

	const {
		flightsBookedByUserAlready = false,
		travelType,
		cities = [],
		enableGetCost,
		departureAirport,
		arrivalAirport,
		departureAirportText,
		departureDate,
		duration,
		hotelGuestRoomConfigurations,
		nationality,
		passenger_details,
		defaultLoginData = {},
		loginError,
	} = state

	const restructuredDepDate = useMemo(() => {
		const seperator = departureDate?.includes('/') ? '/' : '-'
		return getSafariDateFormat({
			date: departureDate,
			format: `dd${seperator}MM${seperator}yyyy`,
			seperator,
		})
	}, [departureDate, visible])

	useEffect(() => {
		if (router.query?.skipGcmFields && isLoggedIn) {
			const leadSourceData = {
				departureDate,
				paxType: passengerType,
				hotelGuestRoomConfigurations,
				departureCity: departureAirportText,
			}
			triggerJourney(userDetails, leadSourceData)
		} else {
			setopenJourneyModal(true)
		}
	}, [router])

	useEffect(() => {
		if (visible) {
			// Fetch cities list if it is not available in context
			// this is used to set the departure/arrival display text
			if (!cities?.length) {
				getIndianCities(response => {
					dispatch({
						type: GCM_INDIAN_CITIES,
						payload: response,
					})
				})
			}

			if (modalName !== 'sb-gcm') {
				dispatch({
					type: COSTING_INFO,
					payload: getGCMDefaultData(itineraryInfo, regionName),
				})
			}

			dispatch({
				type: SET_ENABLE_GET_COST,
				payload: {
					itineraryInfo,
					isLoggedIn,
				},
			})

			dispatch({
				type: GCM_SIGNUP_FAILS_RESET,
				payload: {},
			})

			preloadLibPhoneNumberMetaData()
		}
	}, [visible])

	useEffect(() => {
		setIsSuccess(false)
		setHideCTA(false)
		if (!visible) {
			if (modalName === 'mle-landing') {
				setVisible(true)
				setModalState(DEPARTURE_CITY)
			}

			if (modalName === 'journey' && openJourneyModal) {
				setVisible(true)
				setModalState(JOURNEY)
				console.log({ skipGcmFields: router.query?.skipGcmFields })
				// if (router.query?.skipGcmFields) {
				// 	setModalState(SIGNUP_FORM_GCM)
				// } else {
				// 	setModalState(null)
				// }
			}

			if (modalName === 'get-cost') {
				setVisible(true)

				if (isLoggedIn) {
					setModalState(DEPARTURE_DATE)
				}
			} else if (modalName === 'sb-gcm') {
				dispatch({
					type: UPDATE_COSTING,
					payload: {
						departureDate: dayjs(router.query?.date).format('DD/MMM/YYYY'),
						hotelGuestRoomConfigurations: decodeHotelRoomConfig(
							router.query?.travellers,
						),
					},
				})
				setVisible(true)
				setModalState(DEPARTURE_DATE)
			} else if (modalName === 'gcm-signup') {
				setVisible(true)
				setModalState(SIGNUP_FORM_GCM)
			} else if (modalName === 'pl-gcm' || modalName === 'mle-gcm') {
				setVisible(true)
				if (modalName === 'mle-gcm' && isLoggedIn) {
					setModalState(DEPARTURE_CITY)
					return
				}
				setModalState(isLoggedIn ? DEPARTURE_DATE : PAID_LANDING_GCM)
			} else if (modalName === 'cabin-config') {
				setVisible(true)
				setModalState(CRUISE_CABIN_CONFIG_GCM)
			}
		}
	}, [modalName])

	// useEffect(() => {
	// 	if (isLoggedIn && visible) {
	// 		setModalState(DEPARTURE_DATE)
	// 	}
	// }, [isLoggedIn, visible])

	useDidUpdate(() => {
		if (defaultLoginData.alreadyExist) {
			setModalState(LOGIN_FORM_GCM)
			dispatch({
				type: GCM_PASSENGER_INFO,
				payload:
					defaultLoginData.status === 'MOBILE_EXISTS'
						? {
								countryPhoneCode: defaultLoginData?.defaultCountryPhoneCode,
								mobileNumber: defaultLoginData?.defaulMobileNumber,
						  }
						: { email: defaultLoginData?.defaultEmail },
			})
			setCtaLoading(false)

			dispatch({
				type: LOGIN_ERROR,
				payload: {
					message: null,
				},
			})
		}
	}, [defaultLoginData])

	useDidUpdate(() => {
		if (!visible) {
			if (router.query.m) {
				if (modalName === 'gcm-signup' || modalName === 'sb-gcm') {
					delete router.query.m
					delete router.query.resortCode

					const routerPath = `${locale ? `/${locale}` : ''}${router.pathname}${
						queryString.stringify(router.query)
							? `?${queryString.stringify(router.query)}`
							: ''
					}`
					router.push(routerPath, null, { shallow: true })
				} else {
					const queryParams = { ...router.query }
					delete queryParams.m

					const path = router.asPath.split('?')[0]

					router.push(`${path}`, null, { shallow: true, scroll: false })
				}
			}
		}
	}, [visible])

	const onClose = () => {
		setCtaLoading(false)
		setVisible(false)

		dispatch({
			type: COSTING_INFO,
			payload: getGCMDefaultData(itineraryInfo, regionName),
		})
		if (loginError)
			dispatch({
				type: LOGIN_ERROR,
				payload: {
					message: null,
				},
			})
	}

	const onBack = () => {
		if (
			modalName === 'journey' &&
			(modalState === ROOM_INFO || modalState === DEPARTURE_CITY)
		) {
			setModalState(JOURNEY)
		} else {
			if (isLoggedIn) {
				if (modalState === DEPARTURE_CITY) setModalState(DEPARTURE_DATE)
				else if (modalState === ROOM_INFO) setModalState(DEPARTURE_CITY)
				else if (modalName === 'pl-gcm') setModalState(PAID_LANDING_GCM)
			} else {
				setModalState(null)
				if (modalName === 'pl-gcm' || modalName === 'mle-gcm')
					setModalState(PAID_LANDING_GCM)
				if (modalState === GCM_OTP) setModalState(LOGIN_FORM_GCM)
			}
			if (modalState === LOGIN_FORM_GCM) {
				dispatch({
					type: GCM_RESET_DEFAULT_LOGIN,
				})
			}
			if (otp) setOtp(null)
			if (password) setPassword(null)
			if (otpResponse) setOtpResonse(null)
			if (loginError)
				dispatch({
					type: LOGIN_ERROR,
					payload: {
						message: null,
					},
				})
			setIsSuccess(false)
			setHideCTA(false)
		}
	}

	const triggerCounter = () => {
		let interval
		let count = 20
		if (resendDisable) {
			interval = setInterval(() => {
				if (count !== 1) {
					count -= 1
					setCounter(counter => counter - 1)
				} else {
					clearInterval(interval)
					setResendDisable(false)
					setCounter(20)

					// _this.setState({ disabledResend: false });
				}
			}, 1000)
		} else {
			clearInterval(interval)
		}
	}

	useEffect(() => {
		if (resendDisable && modalState === SET_FORGOT_PASSWORD) {
			triggerCounter()
		}
	}, [resendDisable, modalState])

	useEffect(() => {
		if (regionCode) {
			triggerSimpleAjax({
				locale,
				url: `${AppConfig.api_url}region/${regionCode}/info`,
				method: 'GET',
				onSuccess: ({ data }) => {
					if (data?.nearestAirport?.airportCode) {
						dispatch({
							type: DEPARTURE_AIRPORT_CHANGE,
							payload: {
								departureAirport: data?.nearestAirport?.airportCode,
								departureAirportText: data?.nearestAirport?.cityName,
							},
						})
					} else {
						// Fallback: Set Chennai as Departure city
						dispatch({
							type: DEPARTURE_AIRPORT_CHANGE,
							payload: {
								departureAirport: 'MAA',
								departureAirportText: 'Chennai',
							},
						})
					}
					dispatch({
						type: DEPARTURE_DATE_CHANGED,
						payload: {
							departureDate: dayjs().add(7, 'day').format('DD/MMM/YYYY'),
						},
					})
				},
				onFailure: () => {
					// Fallback: Set Chennai as Departure city
					dispatch({
						type: DEPARTURE_AIRPORT_CHANGE,
						payload: {
							departureAirport: 'MAA',
							departureAirportText: 'Chennai',
						},
					})
					dispatch({
						type: DEPARTURE_DATE_CHANGED,
						payload: {
							departureDate: dayjs().add(7, 'day').format('DD/MMM/YYYY'),
						},
					})
				},
			})
		}
	}, [dispatch, locale, regionCode])

	useEffect(() => {
		dispatch({
			type: GCM_RESET_PASSENGER_INFO,
		})
		setOtpResonse('')
	}, [visible])

	const triggerOtp = isResend => {
		if (isResend) {
			setResendDisable(true)
			triggerCounter()
		}
		let reqObj = {}
		if (validateEmail(passenger_details?.email)) {
			reqObj.email = passenger_details?.email
		} else {
			reqObj.countryPhoneCode = passenger_details?.countryPhoneCode
			reqObj.mobileNumber = passenger_details?.mobileNumber
		}
		triggerForgotPassword({
			reqObj,
			successSubmitCallback: response => {
				setOtpResonse({
					id: response?.data?.id,
					status: response?.data?.status,
					message: response?.data?.statusMessage,
				})
				if (!isResend) {
					setModalState(SET_FORGOT_PASSWORD)
				}
			},
			failureSubmitCallback: data => {
				const { message, status } = data
				setOtpResonse({
					status,
					message,
				})
			},
		})
			.then(() => setCtaLoading(false))
			.catch(() => setCtaLoading(false))
	}

	const triggerGetCost = ({ userDetails, paxType, paxValue }) => {
		if (modalName === 'sb-gcm') {
			router.query.date = dayjs(restructuredDepDate).format('YYYY-MM-DD')
			router.query.duration = duration
			router.query.travellers =
				encodeHotelRoomConfig(hotelGuestRoomConfigurations) || 'a2'
			delete router.query.m
			const routerPath = `${router.pathname}${
				queryString.stringify(router.query)
					? `?${queryString.stringify(router.query)}`
					: ''
			}`

			router.push(routerPath, null, { shallow: true })
			onClose()
			onSuccess && onSuccess()
		} else if (modalName === 'mle-landing') {
			const obj = {
				date: dayjs(restructuredDepDate).format('YYYY-MM-DD'),
				from: departureAirport,
				travellers:
					paxType == 'SOLO'
						? encodeHotelRoomConfig(paxValue)
						: encodeHotelRoomConfig(hotelGuestRoomConfigurations),
				duration,
				nationality: nationality || 'IN',
				arrivalAirportCode: departureAirport,
			}
			if (price) obj.price = price
			router.push(
				`/maldives-tour-packages/listing?${queryString.stringify(obj)}`,
				null,
				{ shallow: true },
			)
		} else if (modalName === 'mle-gcm' && router.query.resortCode) {
			setCtaLoading(true)
			triggerPrecostedMaldivesDeal({
				lastLocation: {
					pathname: router.asPath,
				},
				router,
				passengerConfiguration: hotelGuestRoomConfigurations,
				passengerDetail: passenger_details,
				locale,
				departureDate,
				nights: duration,
				departureAirportCode: departureAirport,
				appDispatch,
				gcmDispatch: dispatch,
				userDetails,
				setCtaLoading,
				setVisible,
				setModalState,
				setShowErrorModal,
			})
		} else if (router.query.resortCode) {
			triggerTourPackageViewDeal({
				lastLocation: {
					pathname: router.asPath,
				},
				router,
				hotelGuestRoomConfigurations,
				passengerDetail: passenger_details,
				locale,
				appDispatch,
				gcmDispatch: dispatch,
				userDetails,
			})
		} else {
			triggerPackageGetCost({
				costingConfig: {
					hotelGuestRoomConfigurations,
					departureAirport,
					arrivalAirport,
					departureDate,
					travelType,
					nationality: nationality ? nationality : 'IN',
				},
				flightsBookedByUserAlready,
				lastLocation: {
					pathname: router.asPath,
				},
				router,
				query: router.query,
				passengerDetail: passenger_details,
				locale,
				appDispatch,
				gcmDispatch: dispatch,
				userDetails,
				setVisible,
				setModalState,
			})
		}
	}

	const triggerJourney = (userDetails, leadSourceData) => {
		triggerRquestCallback({
			reqObj: {
				name: userDetails?.name,
				email: userDetails?.email,
				mobileNumber: userDetails?.mobile,
				countryPhoneCode: userDetails?.countryPhoneCode,
				pageUrl: router.asPath,
				partner: 'CM',
			},
			userDetails,
			leadSourceData: {
				...leadSourceData,
				partner: 'CM',
				keyword: 'clubmahindra',
				utm_source: 'clubmahindra',
				utm_medium: 'affiliate',
			},
			successSubmitCallback: () => {
				setIsSuccess(true)
				setHideCTA(true)
				setCtaLoading(false)
				setTimeout(() => {
					setIsSuccess(false)
					setHideCTA(false)
				}, [5000])
			},
			failureSubmitCallback: () => {
				setIsSuccess(false)
				setHideCTA(false)
			},
			router,
		})
	}

	const paidLandingCtaDisabled = useMemo(
		() =>
			isEmpty(departureAirportText) ||
			isEmpty(departureDate) ||
			!getPaxCount(hotelGuestRoomConfigurations, true) ||
			isEmpty(passenger_details.name) ||
			isEmpty(passenger_details.email) ||
			!validateEmail(passenger_details.email) ||
			isEmpty(passenger_details.mobileNumber) ||
			!isValidMobileNumber(
				passenger_details.countryPhoneCode + passenger_details.mobileNumber,
			),
		[
			departureAirportText,
			departureDate,
			hotelGuestRoomConfigurations,
			passenger_details,
		],
	)

	const journeyCtaDisabled = useMemo(
		() =>
			isEmpty(departureDate) ||
			isEmpty(passengerType) ||
			!getPaxCount(hotelGuestRoomConfigurations, true) ||
			isEmpty(departureAirportText),
		[
			departureDate,
			passengerType,
			hotelGuestRoomConfigurations,
			departureAirportText,
		],
	)

	const handlePaidLandingFlow = () => {
		setModalState(DEPARTURE_CITY)
	}

	// In page modals
	let modalTitle = 'Get trip cost'
	let modalContent = null
	let onSubmit = () => false
	let hideFooter = false
	let hideBackButton =
		modalName === 'gcm-signup' || modalName === 'sb-gcm' || false
	let ctaDisabled = true
	let ctaText = 'View Trip Cost'

	switch (modalState) {
		case DEPARTURE_CITY:
			modalTitle = 'Choose your departure city'
			hideFooter = true
			modalContent = (
				<AirportCityDropdown
					listData={cities}
					isLoggedIn={isLoggedIn}
					callBackAction={() => {
						if (isLoggedIn && modalName === 'journey') {
							setModalState(DEPARTURE_DATE)
							return
						}
						if (isLoggedIn && modalName === 'mle-gcm') {
							setModalState(DEPARTURE_DATE)
							return
						}
						if (modalName === 'mle-landing') {
							setModalState(DEPARTURE_DATE)
						} else {
							setModalState(isLoggedIn ? ROOM_INFO : DEPARTURE_DATE)
						}
					}}
				/>
			)
			break
		case NATIONALITY_GLOBAL:
			modalTitle = 'Choose your nationality'
			hideFooter = true
			modalContent = (
				<AirportCityDropdown
					isLoggedIn={isLoggedIn}
					listData={nationalityCountriesList}
					callBackAction={() =>
						setModalState(isLoggedIn ? ROOM_INFO : DEPARTURE_DATE)
					}
				/>
			)
			break
		case DEPARTURE_DATE:
			modalTitle = 'Choose your date'
			hideFooter = true
			modalContent = (
				<DepartureDate
					isLoggedIn={isLoggedIn}
					onChange={() => {
						if (isLoggedIn) {
							if (modalName === 'journey') {
								setModalState(ROOM_INFO)
							} else if (
								modalName === 'sb-gcm' ||
								modalName === 'mle-gcm' ||
								modalName === 'mle-landing'
							) {
								setModalState(DURATION)
							} else {
								setModalState(DEPARTURE_CITY)
							}
						} else if (modalName === 'mle-landing') {
							setModalState(DURATION)
						} else if (modalName === 'pl-gcm') {
							setModalState(ROOM_INFO)
						} else if (modalName === 'sb-gcm' || modalName === 'mle-gcm') {
							setModalState(DURATION)
						} else {
							onBack()
						}
					}}
					defaultDate={modalName === 'pl-gcm' ? 6 : 2}
				/>
			)
			break
		case DURATION:
			modalTitle = 'Choose your duration'
			hideFooter = true
			modalContent = (
				<Duration
					isLoggedIn={isLoggedIn}
					onChange={duration => {
						dispatch({
							type: UPDATE_COSTING,
							payload: {
								duration,
							},
						})
						// if (modalName === 'mle-gcm') {
						// 	setModalState(DEPARTURE_CITY)
						// 	return
						// }
						setModalState(ROOM_INFO)
					}}
				/>
			)
			break
		case ROOM_INFO:
			ctaDisabled = false
			hideFooter = true
			modalTitle = 'How to configure your rooms?'
			onSubmit =
				modalName === 'journey'
					? () => setModalState(JOURNEY)
					: isLoggedIn || modalName === 'mle-landing'
					? evennt => {
							let paxValue = evennt?.t
							let paxType = evennt?.paxType
							setCtaLoading(true)
							triggerGetCost({ userDetails, paxValue, paxType })
					  }
					: () => {
							setModalState(PAID_LANDING_GCM)
					  }
			modalContent = (
				<RoomsInfo
					showRoomConfig={
						modalName === 'journey' && isLoggedIn
							? false
							: (modalName === 'sb-gcm' || isLoggedIn) &&
							  modalName !== 'mle-landing'
					}
					isLoggedIn={isLoggedIn}
					ctaText={
						modalName === 'journey'
							? 'Continue'
							: modalName === 'sb-gcm'
							? 'Update cost'
							: modalName === 'mle-landing'
							? 'Search Packages'
							: isLoggedIn
							? 'View Trip Cost'
							: 'Continue'
					}
					loading={ctaLoading}
					onSumbit={onSubmit}
					onChange={roomConfig => {
						dispatch({
							type: UPDATE_COSTING,
							payload: {
								hotelGuestRoomConfigurations: roomConfig,
							},
						})
					}}
					setPassengerType={setPassengerType}
				/>
			)
			ctaText = isLoggedIn ? 'View trip cost' : 'Continue'
			break
		case SIGNUP_FORM_GCM:
			ctaDisabled = isSignupFormValid({ ...passenger_details }) ? false : true
			hideBackButton = true
			ctaText = 'View Deal'
			modalTitle = 'Just one step away!'
			hideFooter - isMobile
			onSubmit = () => {
				setCtaLoading(true)
				triggerGetCost({})
			}

			if (openJourneyModal) {
				ctaText = 'Request a callback'
				onSubmit = () => {
					setCtaLoading(true)
					triggerJourney()
				}
			}

			modalContent = (
				<Space
					gutter={24}
					padding={24}
					paddingTop={40}
					paddingBottom={110}
					direction="column"
					overflow={'hidden'}
				>
					{/* <Space.Item width={'100%'}>
						<CustomerEmailOrMobile
							isLoggedIn={isLoggedIn}
							itineraryInfo={itineraryInfo}
							context={GCMContext}
							key="passenger_details"
							defaultLoginData={defaultLoginData}
						/>
					</Space.Item> */}
					<Space.Item width="100%">
						<Space direction="column" gutter={24} width="100%">
							<CustomerName
								labelText={'Lead Passenger Name'}
								isLoggedIn={isLoggedIn}
								itineraryInfo={itineraryInfo}
								context={GCMContext}
								contextKey="passenger_details"
							/>
							<CustomerEmail
								labelText={'Enter Email Id'}
								isLoggedIn={isLoggedIn}
								itineraryInfo={itineraryInfo}
								context={GCMContext}
								contextKey="passenger_details"
							/>
							<CustomerMobile
								labelText={'Enter Mobile Number'}
								isLoggedIn={isLoggedIn}
								itineraryInfo={itineraryInfo}
								context={GCMContext}
								contextKey="passenger_details"
							/>
						</Space>
					</Space.Item>

					{loginError && loginError.message && loginError.message.length > 0 ? (
						<Space direction="column" gutter={0} alignItems="flex-start">
							<Space.Item width={'100%'}>
								<Text
									textAlign="center"
									fontSize={13}
									color={'rgb(191, 54, 74)'}
								>
									{loginError.message}
								</Text>
							</Space.Item>
						</Space>
					) : null}

					{isMobile && (
						<Button
							variant="primary"
							disabled={ctaDisabled}
							onPress={ctaDisabled ? () => false : onSubmit}
							loading={ctaLoading}
							width="100%"
							textProps={{
								fontSize: 18,
								fontWeight: 600,
								color: '#FFFFFF',
							}}
						>
							{ctaText}
						</Button>
					)}
				</Space>
			)

			break
		case LOGIN_FORM_GCM: {
			ctaDisabled = isLoginFormValid({
				...passenger_details,
				...defaultLoginData,
			})
				? false
				: true
			ctaText = 'Login'
			modalTitle = 'Welcome back'
			hideFooter = isMobile
			onSubmit = () => {
				setCtaLoading(true)
				let req_data = {
					password: passenger_details?.loginPassword,
				}

				if (defaultLoginData.status === 'MOBILE_EXISTS') {
					req_data.countryPhoneCode = defaultLoginData.defaultCountryPhoneCode
					req_data.mobileNumber = defaultLoginData.defaulMobileNumber
				} else if (defaultLoginData.status === 'EMAIL_EXISTS') {
					req_data.email = defaultLoginData.defaultEmail
				} else if (emailValidation(passenger_details.email)) {
					req_data.email = passenger_details.email
				} else {
					req_data.countryPhoneCode = passenger_details.countryPhoneCode
					req_data.mobileNumber = passenger_details.mobileNumber
				}

				triggerLogin({
					reqObj: req_data,
					dispatch,
					router,
					lastLocation: {
						pathname: router.asPath,
					},
					successSubmitCallback: userDetails => {
						setCtaLoading(false)
						appDispatch({
							type: SET_USER_DETAILS,
							payload: { ...userDetails, isFetched: true },
						})
						if (
							modalName === 'pl-gcm' &&
							(!departureDate || !departureAirportText)
						) {
							setModalState(DEPARTURE_CITY)
						} else {
							triggerGetCost({ userDetails })
						}
					},
					failureSubmitCallback: ({ error }) => {
						setCtaLoading(false)
						dispatch({
							type: LOGIN_ERROR,
							payload: {
								message: error || 'Unable to login, Please try again!',
							},
						})
					},
				})
			}
			modalContent = (
				<Space
					gutter={24}
					padding={24}
					marginTop={-32}
					paddingBottom={110}
					direction="column"
					overflow={'hidden'}
				>
					<Space direction="column" gutter={0} alignItems="flex-start">
						<Space.Item width={'100%'}>
							<Text
								fontSize={13}
								lineHeight={16}
								color="rgba(119, 119, 119, 1)"
								paddingBottom={24}
							>
								{defaultLoginData?.noteMessage}
							</Text>
							<CustomerEmailOrMobile
								isLoggedIn={isLoggedIn}
								itineraryInfo={itineraryInfo}
								context={GCMContext}
								contextKey="passenger_details"
								defaultLoginData={defaultLoginData}
								disabled={defaultLoginData?.alreadyExist}
							/>
						</Space.Item>
					</Space>

					<Space direction="column" gutter={8}>
						<Space.Item width={'100%'}>
							<CustomerPassword
								labelText="Password"
								isLoggedIn={isLoggedIn}
								itineraryInfo={itineraryInfo}
								context={GCMContext}
								contextKey="passenger_details"
							/>
						</Space.Item>
						<Text
							variant="small"
							textAlign="right"
							fontSize={13}
							fontWeight={600}
							color={'#148099'}
							onClick={() => {
								setOtpResonse({})
								setModalState(GCM_OTP)
							}}
							cursor="pointer"
						>
							Forgot password?
						</Text>
					</Space>

					{loginError && loginError.message && loginError.message.length > 0 ? (
						<Space direction="column" gutter={0} alignItems="flex-start">
							<Space.Item width={'100%'}>
								<Text
									textAlign="center"
									fontSize={13}
									color={'rgb(191, 54, 74)'}
								>
									{loginError.message}
								</Text>
							</Space.Item>
						</Space>
					) : null}

					{isMobile && (
						<Button
							variant="primary"
							disabled={ctaDisabled}
							onPress={ctaDisabled ? () => false : onSubmit}
							loading={ctaLoading}
							width="100%"
							textProps={{
								fontSize: 18,
								fontWeight: 600,
								color: '#FFFFFF',
							}}
						>
							{ctaText}
						</Button>
					)}
				</Space>
			)

			break
		}
		case GCM_OTP:
			modalTitle = 'Retrieve Password'
			hideFooter = isMobile
			ctaDisabled =
				!isEmpty(passenger_details.mobileNumber) &&
				isValidMobileNumber(
					`${
						passenger_details.countryPhoneCode + passenger_details.mobileNumber
					}`,
				)
					? false
					: !isEmpty(passenger_details.email) &&
					  validateEmail(passenger_details.email)
					? false
					: true
			ctaText = 'Get OTP'
			onSubmit = () => {
				setCtaLoading(true)
				setResendDisable(true)
				triggerOtp()
			}
			modalContent = (
				<Space
					gutter={24}
					padding={24}
					paddingTop={40}
					paddingBottom={110}
					direction="column"
					overflow={'hidden'}
				>
					<CustomerEmailOrMobile
						isLoggedIn={isLoggedIn}
						itineraryInfo={itineraryInfo}
						context={GCMContext}
						contextKey="passenger_details"
						defaultLoginData={defaultLoginData}
						disabled
					/>
					{otpResponse && otpResponse.message && (
						<Space direction="column" gutter={0} alignItems="flex-start">
							<Space.Item width={'100%'}>
								<Text
									textAlign="center"
									fontSize={13}
									color={'rgb(191, 54, 74)'}
								>
									{otpResponse?.message}
								</Text>
							</Space.Item>
						</Space>
					)}
					{isMobile && (
						<Button
							variant="primary"
							disabled={ctaDisabled}
							onPress={ctaDisabled ? () => false : onSubmit}
							loading={ctaLoading}
							width="100%"
							textProps={{
								fontSize: 18,
								fontWeight: 600,
								color: '#FFFFFF',
							}}
						>
							{ctaText}
						</Button>
					)}
				</Space>
			)

			break
		case SET_FORGOT_PASSWORD:
			modalTitle = 'Received your OTP?'
			ctaDisabled = !(otp && password)
			ctaText = 'Login'
			hideFooter = isMobile
			onSubmit = () => {
				if (otp?.length < 6) {
					dispatch({
						type: LOGIN_ERROR,
						payload: {
							otp: 'Please enter valid otp.',
							message: 'Please enter valid OTP',
							status: 'SENT',
						},
					})
				} else {
					let reqObj = {}
					if (defaultLoginData.status === 'MOBILE_EXISTS') {
						reqObj.countryPhoneCode = defaultLoginData.defaultCountryPhoneCode
						reqObj.mobileNumber = defaultLoginData.defaulMobileNumber
					} else if (defaultLoginData.status === 'EMAIL_EXISTS') {
						reqObj.email = defaultLoginData.defaultEmail
					} else if (emailValidation(passenger_details.email)) {
						reqObj.email = passenger_details.email
					} else {
						reqObj.countryPhoneCode = passenger_details.countryPhoneCode
						reqObj.mobileNumber = passenger_details.mobileNumber
					}

					setCtaLoading(true)
					triggerLoginWithOTP({
						reqObj: {
							...reqObj,
							otp,
							id: otpResponse.id,
							password,
						},
						lastLocation: {
							pathname: router.asPath,
						},
						eventProps: {
							already_loggedin: false,
							departure_city: departureAirport,
							fromURL: router.asPath,
							departure_date: new Date(departureDate),
							room_count: hotelGuestRoomConfigurations?.length,
							adult_count:
								sumBy(hotelGuestRoomConfigurations, 'adultCount') || 0,
							child_count:
								sumBy(
									hotelGuestRoomConfigurations,
									ch => ch.childAges && (ch.childAges || []).length,
								) || 0,
						},
						successSubmitCallback: newUserDetails => {
							triggerGetCost({ userDetails: newUserDetails })
						},
						failureSubmitCallback: payload => {
							dispatch({
								type: LOGIN_ERROR,
								payload,
							})
						},
						router,
					})
						.then(() => setCtaLoading(false))
						.catch(() => setCtaLoading(false))
				}
			}
			modalContent = (
				<Space
					gutter={24}
					padding={24}
					paddingTop={40}
					paddingBottom={110}
					direction="column"
					overflow={'hidden'}
				>
					<CustomerEmailOrMobile
						isLoggedIn={isLoggedIn}
						context={GCMContext}
						contextKey="passenger_details"
						disabled
					/>
					<Space direction="column">
						<Space.Item width={'100%'}>
							<Text
								variant="small"
								letterSpacing="-0.25px"
								color={'#2C2F42'}
								fontSize={15}
								fontWeight="700"
								fontFamily="Source Sans Pro"
								onClick={() => (resendDisable ? null : triggerOtp(true))}
								cursor={resendDisable ? 'not-allowed' : 'pointer'}
							>
								{otpResponse?.message}
							</Text>
						</Space.Item>
						<Space.Item width={'100%'}>
							<Space direction="row" justifyContent="space-between" gutter={0}>
								<Space.Item width={'72%'}>
									<CustomerPassword
										labelText="Enter OTP"
										isLoggedIn={isLoggedIn}
										context={GCMContext}
										contextKey="passenger_details"
										inputValue={otp}
										onInputChange={e => setOtp(e)}
										newPassword
									/>
								</Space.Item>
								<Space.Item>
									<Text
										variant="small"
										letterSpacing="-0.25px"
										color={resendDisable ? '#aaaaaa' : '#1cad45'}
										fontSize={13}
										onClick={() => (resendDisable ? null : triggerOtp(true))}
										cursor={resendDisable ? 'not-allowed' : 'pointer'}
									>
										Resend?{resendDisable ? ` (${counter}s)` : ''}
									</Text>
								</Space.Item>
							</Space>
						</Space.Item>
						<Space.Item>
							{loginError?.message ? (
								<Text variant="small" color="#f44336" fontSize={13}>
									{loginError.otp}
								</Text>
							) : null}
						</Space.Item>
					</Space>
					<CustomerPassword
						labelText="Set a new password"
						isLoggedIn={isLoggedIn}
						context={GCMContext}
						contextKey="passenger_details"
						inputValue={password}
						onInputChange={e => setPassword(e)}
						newPassword
					/>
					{isMobile && (
						<Button
							variant="primary"
							disabled={ctaDisabled}
							onPress={ctaDisabled ? () => false : onSubmit}
							loading={ctaLoading}
							width="100%"
							textProps={{
								fontSize: 18,
								fontWeight: 600,
								color: '#FFFFFF',
							}}
						>
							{ctaText}
						</Button>
					)}
				</Space>
			)

			break
		case PAID_LANDING_GCM:
			modalTitle = 'Just one more step'
			ctaText = 'View trip cost'
			hideBackButton = true
			ctaDisabled = paidLandingCtaDisabled
			hideFooter = isMobile
			onSubmit = () => {
				setCtaLoading(true)
				triggerGetCost({ userDetails })
			}
			modalContent = (
				<Space
					paddingHorizontal={20}
					width="100%"
					marginTop={!isMobile ? 0 : -24}
					gutter={16}
					direction="column"
				>
					{!isMobile ? (
						<Space.Item width="85%">
							<Text color="#777777" fontSize={13} lineHeight={16}>
								We will need know a bit more about you. We will not spam you
							</Text>
						</Space.Item>
					) : null}
					<Space.Item
						width={isMobile ? 'calc(100% + 40px)' : '100%'}
						minHeight={80}
						paddingVertical={12}
						paddingHorizontal={isMobile ? 20 : 16}
						backgroundColor="#E5F9F3"
						borderRadius={isMobile ? 0 : 4}
						marginHorizontal={isMobile ? -20 : 0}
						marginBottom={8}
					>
						<Space direction="column" gutter={4}>
							<Space gutter={3}>
								{departureAirportText?.split(',')[0] && (
									<Text
										fontSize={14}
										fontWeight={600}
										lineHeight={20}
										color="#333333"
									>
										{departureAirportText?.split(',')[0]} to {destination}
									</Text>
								)}
								<Text fontSize={14} lineHeight={20} color="#333333">
									{restructuredDepDate
										? dayjs(restructuredDepDate).format('ddd, DD MMM')
										: dayjs().add(7, 'day').format('ddd, DD MMM')}{' '}
									- {getPaxCount(hotelGuestRoomConfigurations, true)} pax
								</Text>
							</Space>
							<Text fontSize={13} fontWeight={400} color="#777777">
								{truncate(itineraryTitle, {
									length: 50,
								})}
							</Text>
							<Pressable
								flexDirection="row"
								alignItems="center"
								onPress={handlePaidLandingFlow}
							>
								<Text
									textDecorationLine="underline"
									color="#00B277"
									fontSize={13}
									fontWeight={600}
									paddingRight={4}
								>
									Edit Details
								</Text>
								<ChevronRight width={12} heigh={12} fill="#00B277" />
							</Pressable>
						</Space>
					</Space.Item>
					{isLoggedIn ? null : (
						<Column
							gap="4"
							css={{
								width: '100%',
							}}
						>
							{isLoggedIn ? null : (
								<CustomerName
									labelText={'Lead Passenger Name'}
									isLoggedIn={isLoggedIn}
									itineraryInfo={itineraryInfo}
									context={GCMContext}
									contextKey="passenger_details"
								/>
							)}
							<CustomerEmail
								labelText={'Enter Email Id'}
								isLoggedIn={isLoggedIn}
								itineraryInfo={itineraryInfo}
								context={GCMContext}
								contextKey="passenger_details"
							/>
							<CustomerMobile
								labelText={'Enter Mobile Number'}
								isLoggedIn={isLoggedIn}
								itineraryInfo={itineraryInfo}
								context={GCMContext}
								contextKey="passenger_details"
							/>
							{isMobile && (
								<Space.Item width="100%">
									<Button
										width={'100%'}
										marginTop={8}
										variant="primary"
										disabled={ctaDisabled}
										onPress={ctaDisabled ? () => false : onSubmit}
										loading={ctaLoading}
										height={48}
										textProps={{
											fontSize: 18,
											fontWeight: 600,
											color: '#FFFFFF',
										}}
									>
										{ctaText}
									</Button>
									<Space gutter={2} justifyContent={'center'} paddingTop={16}>
										<Text fontSize={16} lineHeight={20}>
											Have an account?
										</Text>
										<Pressable
											onPress={() => {
												modalTitle = 'Welcome back'
												setModalState(LOGIN_FORM_GCM)
											}}
										>
											<Text
												fontSize={16}
												fontWeight={600}
												color="rgba(0, 178, 119, 1)"
											>
												Login
											</Text>
										</Pressable>
									</Space>
									<Space
										marginTop={16}
										justifyContent="center"
										alignItems="center"
									>
										<Text fontSize={16}>
											or Call us at{' '}
											<a href={`tel:${websiteContactNumber}`}>
												<Text
													fontSize={16}
													fontWeight={600}
													color="#00B277"
													textDecorationLine="underline"
												>
													{websiteContactNumber}
												</Text>
											</a>
										</Text>
									</Space>
								</Space.Item>
							)}
						</Column>
					)}
				</Space>
			)
			break
		case JOURNEY:
			modalTitle = 'Share more details about your trip'
			ctaText = 'Confirm Trip Details'
			hideBackButton = true
			ctaDisabled = journeyCtaDisabled
			hideFooter = isMobile
			onSubmit = () => {
				const leadSourceData = {
					departureDate,
					paxType: passengerType,
					hotelGuestRoomConfigurations,
					departureCity: departureAirportText,
				}
				setCtaLoading(true)
				triggerJourney(userDetails, leadSourceData)
			}
			modalContent = (
				<Space
					paddingHorizontal={20}
					width="100%"
					height="100%"
					marginTop={!isMobile ? 0 : -24}
					gutter={16}
					direction="column"
				>
					{isSuccess ? (
						<Column
							align={'center'}
							gap={4}
							justify="center"
							css={{ height: '350px' }}
						>
							<Box
								css={{
									borderWidth: 2,
									borderColor: '$primary05',
									borderRadius: '$round',
									opacity: 0.9,
									borderStyle: 'solid',
								}}
							>
								<Checkmark fill="#00C684" fontSize={'40px'} />
							</Box>

							<Text
								fontSize={16}
								fontWeight={600}
								color="#333"
								textAlign="center"
							>
								Our travel experts will get in touch with you within 24 hours!
							</Text>
						</Column>
					) : (
						<Column>
							{isLoggedIn && (
								<Space.Item
									width={isMobile ? 'calc(100% + 40px)' : '100%'}
									minHeight={80}
									paddingVertical={12}
									paddingHorizontal={isMobile ? 20 : 16}
									backgroundColor="#E5F9F3"
									borderRadius={isMobile ? 0 : 4}
									marginHorizontal={isMobile ? -20 : 0}
									marginBottom={8}
									gap="2px"
								>
									<Text
										fontSize={14}
										fontWeight={600}
										lineHeight="20px"
										color="#333333"
									>
										{userDetails?.name}
									</Text>
									<Text fontSize={13} lineHeight="16px" color="#777777">
										{userDetails?.mobileNumber
											? userDetails?.mobileNumber + ', '
											: ''}
										{userDetails?.email ? userDetails?.email : ''}
									</Text>
								</Space.Item>
							)}

							<Space.Item gap={20} paddingTop={12}>
								<Input
									placeholder="Departure city"
									value={departureAirportText}
									readOnly
									onClick={() => setModalState(DEPARTURE_CITY)}
									animated
									width={'100%'}
								/>
								<Input
									placeholder="Departure date"
									value={departureDate}
									readOnly
									onClick={() => setModalState(DEPARTURE_DATE)}
									animated
									width={'100%'}
								/>
								<Input
									placeholder="Room configuration"
									value={getCostingText(hotelGuestRoomConfigurations)}
									readOnly
									onClick={() => setModalState(ROOM_INFO)}
									animated
									width={'100%'}
								/>
								{isMobile && (
									<Space.Item width="100%">
										<Button
											width={'100%'}
											marginTop={8}
											variant="primary"
											disabled={ctaDisabled}
											onPress={ctaDisabled ? () => false : onSubmit}
											loading={ctaLoading}
											height={48}
											textProps={{
												fontSize: 18,
												fontWeight: 600,
												color: '#FFFFFF',
											}}
										>
											{ctaText}
										</Button>
									</Space.Item>
								)}
							</Space.Item>
						</Column>
					)}
				</Space>
			)
			break

		default: {
			ctaDisabled = !enableGetCost
			onSubmit = () => {
				setCtaLoading(true)
				triggerGetCost({ userDetails })
			}
			modalContent = (
				<Space
					gutter={24}
					padding={24}
					paddingTop={0}
					paddingBottom={110}
					direction="column"
					overflow={'hidden'}
				>
					{isLoggedIn ? null : (
						<CustomerName
							labelText={'Lead Passenger Name'}
							isLoggedIn={isLoggedIn}
							itineraryInfo={itineraryInfo}
							context={GCMContext}
							contextKey="passenger_details"
						/>
					)}

					<Space direction="column" gutter={0} alignItems="flex-start">
						{/* <FormLabel labelText={'Travelling with'} /> */}
						<Space.Item width={'100%'}>
							<Input
								placeholder="Enter travellers details..."
								value={getCostingText(hotelGuestRoomConfigurations)}
								readOnly
								onClick={() => setModalState(ROOM_INFO)}
								animated
								width={'100%'}
							/>
						</Space.Item>
					</Space>

					<Space gutter={12}>
						<Space.Item width={'calc(50% - 12px)'}>
							{_global_user ? (
								<Space direction="column" gutter={0} alignItems="flex-start">
									{/* <FormLabel labelText={'Nationality'} /> */}
									<Space.Item width={'100%'}>
										<Input
											placeholder="Nationality"
											readOnly
											value={nationality}
											onClick={() => setModalState(NATIONALITY_GLOBAL)}
											animated
											width={'100%'}
										/>
									</Space.Item>
								</Space>
							) : (
								<Space
									direction="column"
									gutter={0}
									alignItems="flex-start"
									width="100%"
								>
									{/* <FormLabel labelText={'Departing from'} /> */}
									<Space.Item>
										<Input
											placeholder="Departure city"
											value={departureAirportText}
											readOnly
											onClick={() => setModalState(DEPARTURE_CITY)}
											animated
											width={'100%'}
										/>
									</Space.Item>
								</Space>
							)}
						</Space.Item>

						<Space.Item width={'50%'}>
							<Space direction="column" gutter={0} alignItems="flex-start">
								{/* <FormLabel
                  labelText={_global_user ? `Arriving on` : `Departure date`}
                /> */}
								<Space.Item width={'100%'}>
									<Input
										placeholder={
											_global_user ? `Arriving on` : `Departure date`
										}
										value={departureDate}
										readOnly
										onClick={() => setModalState(DEPARTURE_DATE)}
										animated
										width={'100%'}
									/>
								</Space.Item>
							</Space>
						</Space.Item>
					</Space>

					{isLoggedIn ? null : (
						<Space.Item width="100%">
							<Space direction="column" gutter={24} width="100%">
								<CustomerEmail
									labelText={'Enter Email Id'}
									isLoggedIn={isLoggedIn}
									itineraryInfo={itineraryInfo}
									context={GCMContext}
									contextKey="passenger_details"
								/>
								<CustomerMobile
									labelText={'Enter Mobile Number'}
									isLoggedIn={isLoggedIn}
									itineraryInfo={itineraryInfo}
									context={GCMContext}
									contextKey="passenger_details"
								/>
							</Space>
						</Space.Item>
					)}

					{isMobile && (
						<Button
							variant="primary"
							disabled={ctaDisabled}
							onPress={ctaDisabled ? () => false : onSubmit}
							loading={ctaLoading}
							width="100%"
							textProps={{
								fontSize: 18,
								fontWeight: 600,
								color: '#FFFFFF',
							}}
						>
							{ctaText}
						</Button>
					)}
				</Space>
			)
		}
	}

	const rightSideContent = (
		<Fragment>
			<ModalHeader
				onLeftClick={
					hideBackButton
						? null
						: (modalState && !isLoggedIn) ||
						  (isLoggedIn && modalState !== DEPARTURE_DATE)
						? onBack
						: null
				}
				isMobile={isMobile}
				onRightClick={onClose}
				title={modalTitle}
			/>
			<ScrollView
				contentContainerStyle={{
					height: '100%',
					paddingTop: 24,
				}}
			>
				{modalContent}
			</ScrollView>
		</Fragment>
	)

	const modalFooter = hideFooter ? null : (
		<FilterFooter
			backgroundColor={'#fff'}
			noShadow
			padding={'24px'}
			// top={isMobile ? `${windowH - 200}px` : undefined}
		>
			{hideCTA ? null : (
				<Button
					variant="primary"
					disabled={ctaDisabled}
					onPress={ctaDisabled ? () => false : onSubmit}
					loading={ctaLoading}
					textProps={{
						fontSize: 18,
						fontWeight: 600,
						color: '#FFFFFF',
					}}
				>
					{ctaText}
				</Button>
			)}
			{modalState === SIGNUP_FORM_GCM || modalState === PAID_LANDING_GCM ? (
				<Space gutter={2} justifyContent={'center'} paddingTop={16}>
					<Text fontSize={16} lineHeight={20}>
						Have an account?
					</Text>
					<Pressable
						onPress={() => {
							modalTitle = 'Welcome back'
							setModalState(LOGIN_FORM_GCM)
						}}
					>
						<Text fontSize={16} fontWeight={600} color="rgba(0, 178, 119, 1)">
							Login
						</Text>
					</Pressable>
				</Space>
			) : null}
			{modalState === PAID_LANDING_GCM ? (
				<Space marginTop={16} justifyContent="center" alignItems="center">
					<Text fontSize={16}>
						or Call us at{' '}
						<a href={`tel:${websiteContactNumber}`}>
							<Text
								fontSize={16}
								fontWeight={600}
								color="#00B277"
								textDecorationLine="underline"
							>
								{websiteContactNumber}
							</Text>
						</a>
					</Text>
				</Space>
			) : null}
		</FilterFooter>
	)

	return (
		<>
			<Modal
				visible={visible}
				containerProps={{
					padding: 0,
					width: isMobile ? '100%' : 624,
					height: isMobile ? '100%' : 600,
					borderRadius: '12px',
					overflow: 'scroll',
				}}
			>
				<ModalWrapper>
					{isMobile ? null : <LeftSideBanner />}
					<RightSideContainer
						pb={modalState === PAID_LANDING_GCM && '0px'}
						width={isMobile ? '100%' : '60%'}
					>
						{rightSideContent}
						{modalFooter}
					</RightSideContainer>
				</ModalWrapper>
			</Modal>

			<Modal
				visible={showErrorModal}
				containerProps={{
					width: isMobile ? '90%' : '478px',
					height: isMobile ? '50vh' : '243px',
					paddingHorizontal: [24, 32],
					paddingVertical: 12,
					borderRadius: 12,
				}}
			>
				<Space
					direction="column"
					justifyContent={'space-between'}
					height={'100%'}
				>
					<Space gutter={0} paddingBottom={14} marginHorizontal={[-24, -32]}>
						{/* header */}
						<Space.Item
							flexDirection={'row'}
							width={'100%'}
							justifyContent={'space-between'}
							paddingHorizontal={24}
						>
							<Text
								fontSize={30}
								fontWeight={600}
								color="#575757"
								textAlign="center"
								marginHorizontal={'auto'}
								width="80%"
								paddingTop={12}
							>
								{/* eslint-disable-next-line jsx-a11y/accessible-emoji */}
								Oh no 😕 Something went wrong!
							</Text>
							<Pressable
								position="absolute"
								right={10}
								onPress={() => setShowErrorModal(false)}
							>
								<CloseLine width={18} height={18} />
							</Pressable>
						</Space.Item>
					</Space>
					{/* body */}
					<Space.Item alignItems={'center'}>
						<Text fontSize={16} color={'#797979'}>
							Unable to create this Itinerary
						</Text>
					</Space.Item>
					<Space.Item alignItems={'center'}>
						{/* eslint-disable-next-line jsx-a11y/accessible-emoji */}
						<Button
							onPress={() => setShowErrorModal(false)}
							textProps={{
								color: '#fff',
								fontWeight: 600,
								fontSize: 17,
							}}
							backgroundColor={'#6FCF97'}
						>
							Okay, got it!
						</Button>
					</Space.Item>
				</Space>
			</Modal>
		</>
	)
}

export default GcmModal
